import { inject, Injectable } from '@angular/core';
import { StepResolverStrategy } from './step-resolver.strategy';
import { Step } from '../../types';
import { Observable, of } from 'rxjs';
import { PaymentStepDefinitionService } from '../step-definition';

@Injectable({
  providedIn: 'root',
})
export class PaymentStepResolverService implements StepResolverStrategy {
  private readonly paymentStepDefinitionStrategy = inject(PaymentStepDefinitionService);

  resolve(): Observable<Step> {
    return of(this.paymentStepDefinitionStrategy.getStepDefinition());
  }
}
